module.exports = __webpack_public_path__ + "images/emails/page-b-46d4c499.gif";